import React, { Component } from 'react'
import { heartRunnerLogin } from '../actions/heartRunnerLoginAction'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import HeartRunnerLoginComponent from '../component/heartRunnerLoginComponent'
import { loggedIn, logOutHeartRunner, logout } from '../actions/heartRunnerLoginAction'
import { withRouter } from 'react-router-dom'

export class HeartLoginContainer extends Component {
    constructor(props) {
        super(props);

        
        logout();
        this.props.actions.logOutHeartRunner();
    }

    componentWillMount() {
        if (loggedIn(this.props.login.authTokenId))
            this.props.history.push('/Admin/Dashboard');
    }

    heartRunnerLogin=(username, password)=> {
        
        this.props.actions.heartRunnerLogin(
            username,
            password,
            this.props.dispatch
        ).then(res => {
            if (loggedIn(this.props.login.authTokenId))
                    this.props.history.push('/HeartRunner/Profile');
            })
            .catch(err => {
                alert(err);
            })
    }

    render() {
        return (
                <HeartRunnerLoginComponent 
                    heartRunnerLogin={this.heartRunnerLogin} 
                    loginDet={this.props.login}>
                </HeartRunnerLoginComponent>
            )

    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            heartRunnerLogin, logOutHeartRunner
        },
            dispatch)
    };
}

function mapStateToProps({ heartRunnerLoginReducer }) {
    return {
        login: {
            userName: heartRunnerLoginReducer.userName,
            isLoading: heartRunnerLoginReducer.isLoading,
            password: heartRunnerLoginReducer.password,
            message: heartRunnerLoginReducer.message,
            loginStatus: heartRunnerLoginReducer.loginStatus,
            authTokenId: heartRunnerLoginReducer.authTokenId,
            adminId: heartRunnerLoginReducer.adminId,
            organizationId: heartRunnerLoginReducer.organizationId,
            adminInfo: heartRunnerLoginReducer.adminInfo,
            
        }
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeartLoginContainer)) 
